import { render, staticRenderFns } from "./industries.vue?vue&type=template&id=07962b9c&scoped=true&"
import script from "./industries.vue?vue&type=script&lang=js&"
export * from "./industries.vue?vue&type=script&lang=js&"
import style0 from "./industries.vue?vue&type=style&index=0&id=07962b9c&scoped=true&lang=scss&"
import style1 from "./industries.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07962b9c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07962b9c')) {
      api.createRecord('07962b9c', component.options)
    } else {
      api.reload('07962b9c', component.options)
    }
    module.hot.accept("./industries.vue?vue&type=template&id=07962b9c&scoped=true&", function () {
      api.rerender('07962b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/industries.vue"
export default component.exports